import api from "@/api";
import {
  destinoDaConfirmacao,
  lerEspera,
  limparEspera,
  marcarEspera,
  rotaDaConsulta,
  type TipoDeEspera,
} from "@/utils/esperaPix";

// Espera do pagamento de um Pix, em qualquer página do site.
//
// O QR mostra o Pix e marca a espera; a partir daí, a cada 5 segundos, e sempre que o
// cliente volta para a aba, o site pergunta ao backend se o pagamento entrou. Recarregar
// a aba não perde a espera: ela é retomada no boot. Pago, o cliente vai para a
// confirmação, esteja onde estiver.
const INTERVALO_MS = 5000;

export default defineNuxtPlugin((nuxtApp) => {
  const router = nuxtApp.$router as ReturnType<typeof useRouter>;
  let intervalo: ReturnType<typeof setInterval> | null = null;
  let consultando = false;

  function parar() {
    if (intervalo) clearInterval(intervalo);
    intervalo = null;
  }

  async function verificar() {
    const espera = lerEspera(sessionStorage);
    if (!espera) {
      parar();
      return;
    }
    if (consultando) return;

    consultando = true;
    try {
      // 200 = pago; qualquer outra resposta cai no catch e a espera segue.
      await api.get(rotaDaConsulta(espera));
    } catch (_e) {
      return;
    } finally {
      consultando = false;
    }

    limparEspera(sessionStorage);
    parar();
    router.push(destinoDaConfirmacao(espera));
  }

  function retomar() {
    if (!lerEspera(sessionStorage)) return;
    void verificar();
    if (!intervalo) intervalo = setInterval(verificar, INTERVALO_MS);
  }

  function comecar(tipo: TipoDeEspera, idioma: string) {
    marcarEspera(sessionStorage, tipo, idioma);
    parar();
    intervalo = setInterval(verificar, INTERVALO_MS);
  }

  // Na volta do app do banco a aba estava congelada: pergunta na hora.
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") retomar();
  });

  nuxtApp.hook("app:mounted", retomar);

  return { provide: { esperaPix: { comecar } } };
});
